import { ChartType } from "./dashboard-tile-node";
import { Tile } from "./tile";

interface TileCollectionParams {
  dashboardId: string;
  tiles: Tile[];
}

export class TileCollection {
  private dashboardId: string;
  private tiles: Tile[];
  observers: Set<() => void>;

  constructor({ dashboardId, tiles }: TileCollectionParams) {
    this.observers = new Set();
    if (dashboardId) {
      this.setDashboardId(dashboardId);
    }

    if (tiles) {
      this.setTiles(tiles);
    } else {
      this.setTiles([]);
    }
  }

  removeNodeFromAllTiles(nodeId: string) {
    for (let i = 0; i < this.tiles.length; i++) {
      for (let j = 0; j < this.tiles[i].getNodes().length; j++) {
        if (this.tiles[i].getNodes()[j].getId() === nodeId) {
          this.tiles[i].removeNodeById(nodeId);
        }
      }
    }
  }

  getTileIdIfNodeIdPresent(nodeId: string): string {
    for (let i = 0; i < this.tiles.length; i++) {
      for (let j = 0; j < this.tiles[i].getNodes().length; j++) {
        if (this.tiles[i].getNodes()[j].getId() === nodeId) {
          return this.tiles[i].getId();
        }
      }
    }

    return "";
  }

  getNodeChartTypeIfNodeIdPresent(nodeId: string): ChartType {
    for (let i = 0; i < this.tiles.length; i++) {
      for (let j = 0; j < this.tiles[i].getNodes().length; j++) {
        if (this.tiles[i].getNodes()[j].getId() === nodeId) {
          return this.tiles[i].getNodes()[j].getChartType();
        }
      }
    }

    return "line";
  }

  getDashboardId(): string {
    return this.dashboardId;
  }

  setDashboardId(dashboardId: string) {
    this.dashboardId = dashboardId;
  }

  getTiles(): Tile[] {
    return this.tiles;
  }

  setTiles(tiles: Tile[]) {
    this.tiles = tiles;
    this.notifyObservers();
  }

  addTile(tile: Tile) {
    this.tiles.push(tile);
    this.notifyObservers();
  }

  removeTileById(tileId: string) {
    this.tiles = this.tiles.filter((tile) => tile.getId() !== tileId);
    this.notifyObservers();
  }

  toJSON() {
    const tilesStructure = [];
    this.tiles.forEach((tile) => {
      tilesStructure.push(tile.toJSON());
    });
    return tilesStructure;
  }

  resetDashboardData() {
    this.dashboardId = "";
    this.tiles = [];
  }

  addObserver(observer: () => void) {
    this.observers.add(observer);
  }

  removeObserver(observer: () => void) {
    this.observers.delete(observer);
  }

  notifyObservers() {
    this.observers.forEach((observer) => observer());
  }
}
